module.exports = __webpack_public_path__ + "media/images/remittees_4-f1c4327e0411e9be8a716529c2941ebf.jpg";